
import { Form, TextField } from "../util";
import { defineComponent } from "vue";

import { specialtyService } from "@/domain/services";
import { SpecialtyBody } from "@/domain/params";
import { SpecialtyModel } from "@/domain/models";

type ComponentData = {
  isLoading: boolean;
  specialties: SpecialtyModel[];
  validations: { [field: string]: { valid: boolean; message?: string } };
  specialty_id?: number;
  body: SpecialtyBody;
  disableButton: boolean;
};

export default defineComponent({
  name: "Specialties",
  components: { Form, TextField },
  data(): ComponentData {
    return {
      specialties: [],
      isLoading: true,
      validations: { description: { valid: false } },
      specialty_id: undefined,
      body: {
        description: "",
      },
      disableButton: false,
    };
  },
  created() {
    this.loadSpecialties();
  },
  computed: {
    isFormValid() {
      for (let field in this.validations)
        if (!this.validations[field].valid) return false;
      return true;
    },
  },
  methods: {
    setToUpdate(id: number, description: string) {
      this.specialty_id = id;
      this.body.description = description;
      this.validations.description = { valid: true };
    },
    deleteSpecialty(id: number) {
      if (confirm("Você realmente deseja remover essa especialidade?")) {
        specialtyService.deleteById(id).then(() => {
          this.loadSpecialties();
        });
      }
    },
    loadSpecialties() {
      this.isLoading = true;
      specialtyService
        .load()
        .then((specialties) => {
          this.specialties = specialties;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    updateValidation(field: string, valid: boolean) {
      this.validations[field].valid = valid;
    },
    save() {
      this.disableButton = true;
      if (this.specialty_id)
        return specialtyService
          .update(this.specialty_id, this.body)
          .then(() => {
            this.disableButton = false;
            this.loadSpecialties();
            this.body.description = "";
            this.specialty_id = undefined;
            this.validations.description.valid = false;
          })
          .catch(() => {
            this.disableButton = false;
          });

      return specialtyService
        .create(this.body)
        .then(() => {
          this.disableButton = false;
          this.loadSpecialties();
          this.body.description = "";
          this.validations.description.valid = false;
        })
        .catch(() => {
          this.disableButton = false;
        });
    },
  },
});
